export const supportEmail = "mailto:support@uptain.de";
export const supportSubject = "Forgot%20registered%20email%20address%20";
